<template>
  <v-data-table
    v-model="selecteds"
    :headers="opt.headers"
    :items="items"
    :show-select="opt.showSelect"
    :single-select="opt.singleSelect"
    :items-per-page=15
    :item-key="opt.itemKey"
    @update:page="updatePage"
    :class="`${opt.classes} mb-3`"
    :loading="loading && loading[register]" 
    :footer-props="{ disableItemsPerPage : true }"
    loading-text="Carregando... Aguarde por favor."
    dense
  >
    <!-- TOP -->
    <template #top>
      <!-- SEARCH -->
      <v-row no-gutters>
        <v-col cols="12">
          <v-toolbar flat color="white">
            <!-- <v-text-field-algolia
              v-model="searchInput"
              @click:clear="algoliaHits = []"
              :index="collection"
              :handler="search"
              :delay="750"
              :filters="algoliaFilters"
              :attributesToHighlight="opt.headers.map(x => x.value)"
              ref="algoliaSearchInput"
              outlined
              dense
              clearable
              hide-details
              height=40
              label="Digite para pesquisar"
              class="mw-20"
              >
            </v-text-field-algolia> -->
            <v-text-field-async
              v-model="searchInput"
              :collection="collection"
              :handler="search"
              :delay="750"
              :filters="computedFilters"
              :fieldsToSearch="opt.headers.filter((x) => x.searchable)"
              :register="register"
              ref="asyncSearchInput"
              dense
              clearable
              hide-details
              height="40"
              label="Digite para pesquisar"
              class="mw-20"
            >
            </v-text-field-async>
          
            <v-btn v-if="computedDataFilters && computedDataFilters.length > 0" height=40 small text outlined class="ml-2" @click="openFilter = !openFilter">Filtros <v-icon right>mdi-filter-menu</v-icon></v-btn>
            
            <v-spacer/>
            
            <v-btn height=40 small text outlined class="mr-4">Opções <v-icon right>mdi-chevron-down</v-icon></v-btn>

            <v-btn v-if="claims.add" :to="`/${register}/cadastrar`" width=35 height=35 fab dark color="indigo darken-2" class="mr-2"><v-icon size=20>mdi-plus</v-icon></v-btn>

            <!-- BUNDLE -->
            <template v-if="bundleActions">
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              
              <!-- EXCLUDE -->
              <!-- <v-dialog
                v-if="claims.delete"
                v-model="dialogBundleRemove"
                persistent
                max-width="500"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="importer()"
                    small
                  >Deletar {{selecteds.length}} itens</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline">
                    Tem certeza que quer deletar os {{selecteds.length}} itens selecionados?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogBundleRemove = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="removeItens()">DELETAR</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
            </template>

            <v-dialog
              v-model="dialogRemoveItem"
              persistent
              max-width="500"
            >
              <v-card>
                <v-card-title class="headline">
                  Tem certeza que quer deletar o item?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeDialogRemoveItem()">Cancelar</v-btn>
                  <v-btn color="error" text @click="removeItem(itemToRemove)">DELETAR</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </v-col>
      </v-row>

      <!-- FILTERS -->
      <v-expand-transition>
        <v-row v-show="openFilter" no-gutters class="mb-4">
          <v-col cols="12">
            <DataTableFilters
              ref="DataTableFilters"
              :filters="computedDataFilters"
              v-on:change="updateSearch"
            />
          </v-col>
        </v-row>
      </v-expand-transition>
    </template>

    <!-- BODY - ROW -->
    <template v-slot:item="{headers, item, isSelected, select}">
      <tr>
        <td v-for="head in headers" :key="head.value" :class="head.tdClass">
          <!-- SELECT ITEM -->
          <template v-if="head.value == 'data-table-select'">
            <v-simple-checkbox color="indigo accent-4" :value="isSelected" @input="select($event)"></v-simple-checkbox>
          </template>

          <!-- STATUS -->
          <template v-if="head.value == 'data-table-status'">
            <v-tooltip v-if="item.errorIntegration" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size=20 color="error" v-bind="attrs" v-on="on">mdi-close</v-icon>
              </template>
              <span>Erro na sincronia</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.aguardando" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size=20 v-bind="attrs" v-on="on">mdi-clock-outline</v-icon>
              </template>
              <span>Aguardando</span>
            </v-tooltip>
            <v-tooltip v-else-if="proccessItem({item, head: {value: 'lifeControl.integratedAt'}}) == null" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size=20 color="success" v-bind="attrs" v-on="on">mdi-check</v-icon>
              </template>
              <span>Gravado</span>
            </v-tooltip>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size=20 color="indigo" v-bind="attrs" v-on="on">mdi-check-all</v-icon>
              </template>
              <span>Sincronizado</span>
            </v-tooltip>
          </template>

          <!-- ACTIONS -->
          <template v-if="head.value == 'data-table-actions'">
            <v-tooltip top v-if="!item.submitToApproval || !claims.approval">
              <template #activator="{ on, attrs }">
                <v-btn
                  v-if="claims.view"
                  :to="`/${register}/detalhes/${item.id}`"
                  icon
                  x-small
                  color="success lighten-1"
                  class="mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              Visualizar
            </v-tooltip>
            <!-- TO-DO -->
            <!-- Lembrar de tirar esse trecho ou tratar ele como uma clain -->
            <!-- Foi criado assim devido a pressa para entregar uma demanda -->
            <v-tooltip v-if="claims.add && register.includes('SC5') && item.C5_NUM && !item.C5_YPEDORI && (! $appConfig.claims || $appConfig.claims.bonus )" top>
              <template #activator="{ on, attrs }">
                <v-btn
                  :to="`/${register}/bonificar/${item.id}`"
                  icon
                  x-small
                  color="indigo accent-4"
                  class="mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                  <v-icon small>mdi-gift</v-icon>
                </v-btn>
              </template>
              Bonificar
            </v-tooltip>
            <!-- TO-DO -->
            <v-tooltip v-if="claims.edit && !item[blockedField]" top>
              <template #activator="{ on, attrs }">
                <v-btn
                  :to="`/${register}/editar/${item.id}`"
                  icon
                  x-small
                  color="indigo accent-4"
                  class="mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              Editar
            </v-tooltip>            
            <v-tooltip v-if="item.submitToApproval && claims.approval" top>
              <template #activator="{ on, attrs }">
                <v-btn
                  :to="`/${register}/detalhes/${item.id}`"
                  icon
                  x-small
                  color="yellow darken-3"
                  class="mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                  <v-icon small>mdi-file-eye-outline</v-icon>
                </v-btn>
              </template>
              Aprovar/Reprovar
            </v-tooltip>
            <v-tooltip v-if="claims.delete && !item[blockedField]" top>
              <template #activator="{ on, attrs }">
                <v-btn
                  @click="confirmRemove(item)"
                  icon
                  x-small
                  color="error darken-1"
                  class="ml-n1 mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              Remover
            </v-tooltip>
            <v-tooltip v-if="claims.delete && !item[blockedField] && head.dispatch" top>
              <template #activator="{ on, attrs }">
                <v-btn
                  @click="dispatchAction({action: head.dispatch.action, params: proccessParams({params: head.dispatch.params, item})})"
                  icon
                  x-small
                  color="indigo accent-4"
                  class="ml-n1 mr-2 no-hover"
                  v-on="on"
                  v-bind="attrs"
                  >
                  <v-icon small>{{head.dispatch.icon}}</v-icon>
                </v-btn>
              </template>
              {{ head.dispatch.text }}
            </v-tooltip>
          </template>

          <!-- Markers -->
          <v-tooltip v-if="head.markers && proccessItem({item, head})" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                >
                <v-badge 
                  v-bind="attrs"
                  v-on="on"
                  inline 
                  :color="head.markers[proccessItem({item, head: {...head, lower: true, trim: true}})] || 'transparent'" 
                  class="small"
                  />
              </v-btn>
            </template>
            <span class="text-capitalize">{{ proccessItem({item, head: {...head, lower: true, trim: true} }) }}</span>
          </v-tooltip>
          
          <!-- CHECKBOX -->
          <template v-else-if="head.checkbox">
            <v-simple-checkbox color="indigo accent-4" :value="proccessItem({item, head})" @input="toggleCk({item, head})" 
            :disabled="(typeof head.disabled == 'string') ? item[head.disabled] : head.disabled"></v-simple-checkbox>
          </template>
          
          <!-- CHIPS -->
          <template v-else-if="head.chips">
            <span v-for="(tag, ix) in proccessItem({item, head})" :key="tag+ix">
              <v-chip 
                v-if="ix < dataTableChips" 
                small 
                color="indigo accent-4"
                dark
                class="mr-1 mb-1">
                {{ tag }}
              </v-chip>
              <span
                v-if="ix == dataTableChips"
                class="grey--text caption"
              >(+{{ proccessItem({item, head}).length - dataTableChips }} outro(s))</span>
            </span>
          </template>

          <!-- COPY ITEM -->
          <template v-else-if="head.copy">
            <v-btn x-small fab icon color="indigo" class="mr-1" :key="proccessItem({item, head, copy:true})"
              v-clipboard:copy="proccessItem({item, head, copy:true})"
              v-clipboard:success="clipboardCopy"
              v-clipboard:error="clipboardError"
              >

              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <span v-if="!head.hide" v-html="proccessItem({item, head})"></span>
          </template>
     
          <!-- CLICK ITEM -->
          <template v-else-if="head.click">
            <v-btn outlined x-small fab color="indigo" class="no-hover mr-1"
              :href="proccessItem({item, head})"
              target="_blank"
              >
              <v-icon>mdi-cursor-default-click-outline</v-icon>
            </v-btn>
          </template>

          <!-- AVATAR -->
          <template v-else-if="head.avatar">
            <v-list-item-avatar>
              <img
                v-if="proccessItem({item, head})"
                alt="Avatar"
                :src="proccessItem({item, head})"
              >
              <v-gravatar 
                v-else
                default-img="mm"
                :email="item.email" />
            </v-list-item-avatar>
          </template>

          <!-- OTHERS -->
          <template v-else>
            <span v-html="proccessItem({item, head})"></span>
          </template>
        </td>
      </tr>
    </template>

    <template v-if="opt.serverItemsLength" v-slot:footer.page-text="{pageStart, pageStop}">
      {{pageStart}} - {{pageStop}} de {{registersCount}}
    </template>
  </v-data-table>
</template>

<script>
// import VTextFieldAlgolia from '../VTextFieldAlgolia.vue'
import VTextFieldAsync from "../VTextFieldAsync.vue";
import DataTableFilters from './DataTableFilters.vue'
import { createNamespacedHelpers, mapActions, mapState } from 'vuex'
const { mapState:registersState, mapActions:registersActions } = createNamespacedHelpers('registers')
const { mapState:authState } = createNamespacedHelpers('auth')
import algoliasearch from 'algoliasearch/lite'
export default {
  name: "DataTable",
  components: { VTextFieldAsync, DataTableFilters },
  props: {
    opt: Object,
    collection: String,
    register: String,
    details: Array,
    claims: Object,
    blockedField: String,
    integration: Boolean,
    dataFilters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      openFilter: false,
      dialog: false,
      dialogImporter: false,
      dialogRemoveItem: false,
      selected: [],
      saveValid: true,
      importValid: true,
      selecteds: [],
      bundleActions: false,
      dialogBundleRemove: false,
      itemLoaded: {},
      itemComputed: {},
      itemToRemove: {},
      showPassword: false,
      method: 'new',
      searchAutocomplete: null,
      loadingAutocomplete: false,
      querySelection: null,
      dataTableChips: 1,
      formChips: 4,
      vjsf: {},
      searchInput: "",
      algoliaHits: [],
      algoliaFilters: [],
      filtersComponent: [],
    }
  },
  computed: {
    ...registersState(['registers', 'counters', 'loading']),
    ...mapState(['algolia']),
    ...authState(['user']),
    items() {
      // return (this.searchInput && this.searchInput.length > 0) || this.algoliaFilters.length > 0
      //   ? this.algoliaHits
      //   : this.opt.items || []
      return (this.searchInput && this.searchInput.length > 0) ||
          (this.filtersComponent && this.filtersComponent.length > 0)
            ? this.registers[`${this.register}Filtered`]
            : this.opt.items || [];
    },
    registersCount() { 
      // return this.algoliaHits.length || this.counters[this.collection] 
      return (this.searchInput && this.searchInput.length > 0) ||
          (this.filtersComponent && this.filtersComponent.length > 0)
          ? this.counters[`${this.register}Filtered`]
          : this.counters[this.register] || 0;
    },
    computedFilters() {
      return this.filtersComponent
    },
    computedDataFilters() {
      return this.user?.claims?.admin
        ? this.dataFilters
        : this.dataFilters.filter(filter => filter.userRules?.some(ur => this.user?.rules?.indexOf(ur) >= 0))
    },
  },
  watch: {
    selecteds: {
      handler: function(newValue) {
        this.bundleActions = (newValue.length > 1)
      },
    },
    itemLoaded: {
      handler: function(newValue) {
        const inputs = this.opt.form.inputs
        const jsoneditorValues = inputs.filter(x => x.type == 'jsoneditor').map(x => x.value)
        jsoneditorValues.forEach(el => {
          if (!newValue[el]) return
          this.itemComputed[el] = this.$_.cloneDeep(newValue[el])
          const properties = Object.fromEntries(Object.entries(this.itemComputed[el].properties).sort(([,a],[,b]) => a.order - b.order))
          this.itemComputed[el].properties = properties
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['dispatchAction']),
    ...registersActions(['save', 'remove', 'import', 'nextObserver', 'getDetails', 'get', 'removeBundle']),
    initialize() {
      const inputs = this.opt.form.inputs
      inputs.forEach((el, ix) => {
        this.$set(inputs[ix], 'showPassword', false)
      });
    },
    updatePage(e) {
      if (e === 1) return;
      if ((this.searchInput && this.searchInput.length > 0) || (this.filtersComponent && this.filtersComponent.length > 0)) {
        this.nextOnMongo({register: `${this.register}Filtered`})
      } else {
        this.nextObserver({ register: this.register, limit: this.itensPerPage*2 });
      }
    },
    selectAll ({items, value, itemValue}) {
      this.$nextTick(() => {
        if (items && this.itemLoaded[value] && this.itemLoaded[value].length >= items.length) {
          this.$set(this.itemLoaded, value, []) 
        } else if (items) {
          this.$set(this.itemLoaded, value, (itemValue) ? items.map(x => x[itemValue]).slice() : items.slice()) 
        }
      })
    },
    querySelections (query, {collection, register, filters, orderBy}) {
      clearTimeout(this.querySelection)
      this.querySelection = setTimeout(async () => {
        if (!query || !collection || !register || !orderBy) return
        this.loadingAutocomplete = true
        this.get({collection, register, orderBy, filters, query})
          .then(() => this.loadingAutocomplete = false)
      }, 500)
    },
    proccessItem({item, head, copy = false}) {
      let ret = this.$_.cloneDeep(item)
      if (!ret) return
      if (
        ret._highlightResult 
        && ret._highlightResult[head.value] 
        && ret._highlightResult[head.value].matchedWords
        && ret._highlightResult[head.value].matchedWords.length > 0
      ) ret = ret._highlightResult
      
      /* NESTED */ 
      const pathItem = head.value.split('.')
      const lenItem = pathItem.length
      if (lenItem == 1) {
        ret = ret[pathItem]
      } else {
        for (let ix = 0; ix < pathItem.length; ix++) {
          const el = pathItem[ix];
          if (ret && typeof ret[el] != 'undefined') { ret = ret[el] }
          else { 
            ret = (head.checkbox) ? false : ''
            break; 
          }
        }
      }

      /* ASSIST */ 
      const detail = head.detail
      if (detail && ret) {
        const pathAssist = detail.split('.')
        const lenAssist = pathAssist.length
        if (Array.isArray(ret)) {
          ret.forEach((el, ix) => {
            let retEl = (this.registers[pathAssist[0]]) ? this.registers[pathAssist[0]].find(x => x.id === el) : null
            if (retEl) {
              for(let i = 1; i < lenAssist; i++) {
                const el2 = pathAssist[i];
                retEl = (retEl) ? retEl[el2] : ''
              }
              ret[ix] = retEl
            }
          })
        } else {
          let retEl = (this.registers[pathAssist[0]]) ?  this.registers[pathAssist[0]].find(x => x.id === ret) : null
          for(let i = 1; i < lenAssist; i++) {
            const el = pathAssist[i];
            retEl = (retEl) ? retEl[el] : ''
          }
          ret = retEl
        }
      }

      /* FORMATS */ 
      if (!ret) return
      if (ret && ret.value) ret = ret.value
      if (head.slice && !copy) { ret = ret.slice(head.slice) }
      if (head.upper) { ret = ret.toUpperCase() }
      if (head.lower) { ret = ret.toLowerCase() }
      if (head.trim) { ret = ret.trim() }
    
      /* FORMAT DATES */
      if (head.date || head.dateHour || head.dateYear || head.datePlusWeek) { 
        if (Object.prototype.hasOwnProperty.call(ret, "toDate")) ret = ret.toDate()
        else if (ret.seconds && ret.nanoseconds) ret = new this.$db.Timestamp(ret.seconds, ret.nanoseconds).toDate() // Retorno via Algolia não contem metodo toDate
      }
      if (head.date) { ret = this.$moment(ret).format("DD/MM/YYYY") }
      if (head.dateHour) { ret = this.$moment(ret).format("DD/MM/YYYY - HH:mm:ss") }
      if (head.dateYear) { ret = this.$moment(ret).format("YYYY") }
      if (head.datePlusWeek) { ret = this.$moment(ret).format("DD/MM/YYYY, dddd") }
   
      // if (options.slice) { obj = (obj) ? obj.slice(options.slice) : '' }
      // if (options.multiplier) { obj = (obj) ? obj * options.multiplier : '' }

      return ret
    },
    proccessParams({item, params}) {
      const ret = {}
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          const el = params[key]
          const pathItem = el.split('.')
          const lenItem = pathItem.length
          if (lenItem == 1) {
            ret[key] = pathItem[0]
          } else {
            for (let ix = 1; ix < pathItem.length; ix++) {
              const el2 = pathItem[ix];
              if (typeof item[el2] != 'undefined') { ret[key] = item[el2] }
              else { ret[key] = '' ; break }
            }
          }
        }
      }
      return ret
    },
    newItem () {
      this.itemLoaded = {}
      this.method = 'new'
      const inputs = this.opt.form.inputs
      inputs.forEach(el => {
        if (el.default) { this.itemLoaded[el.value] = el.default }
      });
    },
    importer () {
      this.itemLoaded = {}
      this.method = 'import'
    },
    closeDialog () {
      this.dialog = false
    },
    closeDialogImporter () {
      this.dialogImporter = false
    },
    clipboardCopy: function (e) {
      this.$toast.success('Copiado');
    },
    clipboardError: function (e) {
      this.$toast.error('Falha ao copiar');
    },
    toggleCk({item, head}) {
      const pathItem = head.value.split('.');
      const lenItem = pathItem.length;
      let schema = item; 
      for(let i = 0; i < lenItem-1; i++) {
        const el = pathItem[i];
        if(!schema[el]) schema[el] = {}
        schema = schema[el];
      }
      schema[pathItem[lenItem-1]] = !schema[pathItem[lenItem-1]]
      
      this.saveItem(item)
    },
    removeChip({value, item, itemValue}) {
      const ix = this.itemLoaded[value].findIndex(x => x == item[itemValue] )
      if (ix > -1) this.itemLoaded[value].splice(ix, 1)
    },
    editItem(item) {
      // Details
      if (this.details) {
        this.details.forEach(detail => {
          this.getDetails({item: this.$_.cloneDeep(item), detail: this.$_.cloneDeep(detail), endSlice: this.formChips+1})
        });
      }

      // Order Json
      const inputs = this.opt.form.inputs
      const jsoneditorValues = inputs.filter(x => x.type == 'jsoneditor').map(x => x.value)
      jsoneditorValues.forEach(el => {
        if (!item[el]) return
        const properties = Object.fromEntries(Object.entries(item[el].properties).sort(([,a],[,b]) => a.order - b.order))
        item[el].properties = properties
      });

      // Load Item
      this.itemLoaded = this.$_.cloneDeep(item)
      this.method = 'edit'
      this.dialog = true
    },
    saveItem(item) {
      if(this.$refs.save && !this.$refs.save.validate()) return

      // Dispatch Before
      if (this.opt.dispatch) {
        this.opt.dispatch.filter(x => x.when == 'before' && x.method == this.method).forEach(el => {
          if (!el.switch || item[el.switch]) {
            this.dispatchAction({action: el.action, params: this.proccessParams({params: el.params, item})})
          }
        });
      }

      this.save({collection: this.collection, item})
        .then(() => {
          // Dispatch After
          if (this.opt.dispatch) {
            this.opt.dispatch.filter(x => x.when == 'after' && x.method == this.method).forEach(el => {
              if (!el.switch || item[el.switch]) {
                this.dispatchAction({action: el.action, params: this.proccessParams({params: el.params, item})})
              }
            });
          }

          this.closeDialog()
        })
        .catch(error => console.error(error))
    },
    confirmRemove(item) {
      this.itemToRemove = this.$_.cloneDeep(item)
      this.dialogRemoveItem = true
    },
    removeItem(item) {
      this.remove({collection: this.collection, integration: this.integration, item})
      this.dialogRemoveItem = false
    },
    removeItens() {
      this.removeBundle({collection: this.collection, integration: this.integration, itens: this.selecteds})
        .then(() => {
          this.selecteds = []
          this.dialogBundleRemove = false
        })
        .catch(error => {})
    },
    closeDialogRemoveItem () {
      this.itemToRemove = this.$_.cloneDeep({})
      this.dialogRemoveItem = false
    },
    sendImport(item) {
      if(this.$refs.import && !this.$refs.import.validate()) return

      this.import({collection: this.collection, item})
        .then(() => this.closeDialogImporter())
        .catch(error => {})
    },
    async searchold (req) {
      try {
        const { hits } = await req
        this.algoliaHits = hits
      } catch (err) {
        console.error(err)
        this.algoliaHits = []
      }
    },
    async search(req) {
      try {
        const { hits } = await req;
        this.searchResult = hits;
      } catch (err) {
        console.error(err);
        this.searchResult = [];
      }
    },
    updateSearch(filters) {
      this.filtersComponent = filters;
      this.$refs['asyncSearchInput'].search(this.searchInput, this.filtersComponent);
    },
    searchAlgolia(algoliaFilters) {
      this.algoliaFilters = algoliaFilters
      this.$refs.algoliaSearchInput.search(this.searchInput, algoliaFilters)
    },
  },
}
</script>

<style>

</style>